import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const InfoItem = styled.span`
  font-size: 14px;
  align-self: center;
  letter-spacing: 0.2px;
  width: fit-content;
  ${media.phone`
    font-size: 12px;
    line-height: 22px;
  `}
`;

export const TimeLeft = styled(InfoItem)`
  color: ${({ theme }) => theme.red.a10};
  font-weight: 500;
`;

export const NavigationContainer = styled.div`
  align-items: center;
  justify-items: center;
  ${media.phone`
    width: 100%;
  `}
`;

export const QuestionsAmount = styled(InfoItem)`
  color: ${({ theme }) => theme.white.a5};
`;

export const CardContainer = styled.form<{ $inModal?: boolean, $isCommentField?: boolean }>`
  margin: ${({ $inModal }) => ($inModal ? '-30px 0 -30px -30px' : 'none')};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 50rem;
  min-height: ${({ $isCommentField }) => ($isCommentField ? '33.333rem' : '28rem')};
  border-radius: 5px;
  box-shadow: 0 4rem 5rem -2rem rgba(0, 0, 0, 0.42);
  ${media.tablet`
    width: auto;
  `}
  ${media.phone`
    width: 100%;
    min-width: 300px;
    max-width: 300px;
    min-height: 340px;
  `}
`;

export const CardsContainer = styled.section`
  @media only screen and (min-height: 833px) {
    display: block;
  }

  overflow: hidden;
  max-width: 100vw;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 50px 120px;
  background-image: radial-gradient(
    circle at 50% 40%,
    ${({ theme }) => `${theme.baseBlue.a9}, ${theme.baseBlue.a10}`}
  );
  height: auto;
  min-height: 100%;
  ${media.tablet`
    padding: 20px 20px 0;
  `}
  ${media.phone`
    padding: 20px 0 0 0;
    width: 100%;
    background-image: none;
    background-color: ${({ theme }) => theme.mobileBlue.a10};
    position: relative;
  `}
`;
